const ANSWERS = {
  YES: 'JA',
  NO: 'NEIN',
  SKIP: 'skip'
};

export default ANSWERS;
